<div mat-dialog-title class="dialogContainer dialog-error">
    <label class="labelTitle">
        {{'ERROR' | translate}}
    </label> 
</div>

<mat-dialog-content class="dialogContent">
    <p class="invalidMessage">{{'VERIFY_COLLABORATORS_DIALOG_INVALID_MESSAGE' | translate}}</p>
    <p class="viabilityCheck" [innerHTML]="message"></p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button mat-raised-button color="warn" 
    [mat-dialog-close]>{{'OK_BTN_LABEL' | translate}}</button>
</mat-dialog-actions>
